<template>
    <performance-common-dialog
        :title="'发车单上传运输协议页面'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="config.form"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发车单号：" prop="dispatchNo">
                            <span>{{ componentsData.dispatchNo }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车牌号：" prop="vehicleCard">
                            <span>{{ componentsData.vehicleCard }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="司机：" prop="driver">
                            <span>{{ componentsData.driver }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="司机联系方式："
                            prop="driverContactWay"
                        >
                            <span>{{ componentsData.driverContactWay }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template #table-list>
            <dispatch-transport-proto-table
                :componentsData="componentsData"
            ></dispatch-transport-proto-table>
        </template>
    </performance-common-dialog>
</template>
<script>
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchTransportProtoTable from './DispatchTransportProtoTable';
import config from './config.js';

export default {
    name: 'dispatchOrder',
    components: { PerformanceCommonDialog, DispatchTransportProtoTable },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        }
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
</style>
